const hasProtocol = (value) => /^https?:\/\//i.test(value)

const normalizeUrl = (value) => {
  if (!value) return ''
  return hasProtocol(value) ? value : `https://${value}`
}

const trimTrailingSlash = (value) => value.replace(/\/$/, '')

const getServerSideURL = () => {
  const envUrl = process.env.GATSBY_PUBLIC_SERVER_URL || process.env.SITE_URL

  if (!envUrl) {
    return 'http://localhost:3000'
  }

  return trimTrailingSlash(normalizeUrl(envUrl))
}

module.exports = {
  getServerSideURL,
}
